var _Immutable;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Immutable from 'seamless-immutable';
import { CUSTOMER_QUICK_ACTION_IDS } from 'invision-core/src/components/configurable/customercare';
import CustomerCareLocaleKeys from '../../locales/keys';
import { ORDER_ACCESS, ORDERING_ACCESS, RESET_SUBSCRIBER_PASSWORD_ACCESS, SUBSCRIBER_ADMIN_ACCESS, SUBSCRIBER_BYPASS_RESET_PASSWORD, SUBSCRIBER_HIERARCHY_ACCESS } from '../../security.attributes';

/*
    Quick Action Data Structure:
        id - Required: This ID should be generated in invision-core to ensure it remains the same across the app
        securityAttributes - Optional: The security attributes are run through the PermissionsService.hasAccess function,
            if any of the attributes are not met, then the action is not added to the collection
        adminAttributes - Optional: The security attributes are run through PermissionsService.hasAdminAccess function
        lockMessage - Optional: If an action is lockable, the key will be translated and set onto the quick action
*/
export var CUSTOMER_WRAP_UP_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.CUSTOMER_WRAP_UP,
  securityAttributes: []
};
export var DISCONNECT_CUSTOMER_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.DISCONNECT_CUSTOMER,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS],
  lockMessage: CustomerCareLocaleKeys.PENDING_OFFERS_CAN_NOT_FULL_DISCONNECT
};
export var NEW_DBSS_ORDER_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.NEW_DBSS_ORDER,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS],
  lockMessage: CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.CONVERGENT_BILLER_ERROR
};
export var NEW_PRODUCT_ORDER_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.NEW_PRODUCT_ORDER,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS],
  lockMessage: CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.CONVERGENT_BILLER_ERROR
};
export var OPEN_CASE_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.OPEN_CASE,
  securityAttributes: []
};
export var REDEEM_GIFT_ORDER_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.REDEEM_GIFT_ORDER,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS]
};
export var RESET_DEVICE_PIN_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.RESET_DEVICE_PIN,
  securityAttributes: [SUBSCRIBER_ADMIN_ACCESS],
  adminAttributes: [SUBSCRIBER_ADMIN_ACCESS]
};
export var RESET_PASSWORD_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.RESET_PASSWORD,
  securityAttributes: [RESET_SUBSCRIBER_PASSWORD_ACCESS]
};
export var RESUME_ORDER_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.RESUME_ORDER,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS]
};
export var CLEAR_SAVED_CART_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.CLEAR_SAVED_CART,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS]
};
export var REVIEW_STORE_ORDER_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.REVIEW_STORE_ORDER,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS]
};
export var CANCEL_STORE_ORDER_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.CANCEL_STORE_ORDER,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS]
};
export var START_NEW_SUBSCRIPTION_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.START_NEW_SUBSCRIPTION,
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ORDERING_ACCESS],
  lockMessage: CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.CONVERGENT_BILLER_ERROR
};
export var UNREVOKE_LOGIN_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.UNREVOKE_LOGIN,
  securityAttributes: [SUBSCRIBER_BYPASS_RESET_PASSWORD]
};
export var VALIDATE_PIN_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.VALIDATE_PIN
};
export var CHANGE_BILLING_TYPE_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.CHANGE_BILLING_TYPE
};
export var MANAGE_SERVICES_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.MANAGE_SERVICES,
  securityAttributes: [SUBSCRIBER_HIERARCHY_ACCESS]
};
export var CREATE_COMMERCIAL_CHILD_QUICK_ACTION = {
  id: CUSTOMER_QUICK_ACTION_IDS.CREATE_COMMERCIAL_CHILD
};
export var QUICK_ACTIONS_MAP = Immutable((_Immutable = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Immutable, CANCEL_STORE_ORDER_QUICK_ACTION.id, CANCEL_STORE_ORDER_QUICK_ACTION), CLEAR_SAVED_CART_QUICK_ACTION.id, CLEAR_SAVED_CART_QUICK_ACTION), CREATE_COMMERCIAL_CHILD_QUICK_ACTION.id, CREATE_COMMERCIAL_CHILD_QUICK_ACTION), CUSTOMER_WRAP_UP_QUICK_ACTION.id, CUSTOMER_WRAP_UP_QUICK_ACTION), CHANGE_BILLING_TYPE_QUICK_ACTION.id, CHANGE_BILLING_TYPE_QUICK_ACTION), DISCONNECT_CUSTOMER_QUICK_ACTION.id, DISCONNECT_CUSTOMER_QUICK_ACTION), MANAGE_SERVICES_QUICK_ACTION.id, MANAGE_SERVICES_QUICK_ACTION), NEW_DBSS_ORDER_QUICK_ACTION.id, NEW_DBSS_ORDER_QUICK_ACTION), NEW_PRODUCT_ORDER_QUICK_ACTION.id, NEW_PRODUCT_ORDER_QUICK_ACTION), OPEN_CASE_QUICK_ACTION.id, OPEN_CASE_QUICK_ACTION), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Immutable, REDEEM_GIFT_ORDER_QUICK_ACTION.id, REDEEM_GIFT_ORDER_QUICK_ACTION), RESET_DEVICE_PIN_QUICK_ACTION.id, RESET_DEVICE_PIN_QUICK_ACTION), RESET_PASSWORD_QUICK_ACTION.id, RESET_PASSWORD_QUICK_ACTION), RESUME_ORDER_QUICK_ACTION.id, RESUME_ORDER_QUICK_ACTION), REVIEW_STORE_ORDER_QUICK_ACTION.id, REVIEW_STORE_ORDER_QUICK_ACTION), START_NEW_SUBSCRIPTION_ACTION.id, START_NEW_SUBSCRIPTION_ACTION), UNREVOKE_LOGIN_QUICK_ACTION.id, UNREVOKE_LOGIN_QUICK_ACTION), VALIDATE_PIN_QUICK_ACTION.id, VALIDATE_PIN_QUICK_ACTION)));